let timeoutId

function notify({ commit }, { newNotification, timeout = 3000 }) {
  commit('addNotification', newNotification)
  clearTimeout(timeoutId)
  timeoutId = setTimeout(function() {
    commit('removeNotification')
  }, timeout + 500)

  this._vm.$bvToast.toast(newNotification.message, {
    title: 'Értesítés',
    variant: newNotification.type,
    solid: true,
    appendToast: true,
    toaster: 'b-toaster-bottom-right',
    autoHideDelay: 2000
  })
}

function clearNotification({ commit }) {
  clearTimeout(timeoutId)
  commit('removeNotification')
}

function addNotification(state, newNotification) {
  state.notification = newNotification
}

function removeNotification(state) {
  state.notification = null
}

const notificationStore = {
  state: { notification: undefined },
  actions: {
    notify,
    clearNotification
  },
  mutations: {
    addNotification,
    removeNotification
  },
  getters: {
    message(state) {
      return state.notification?.message ? state.notification.message : 'Placeholder Notification Message'
    },
    variant(state) {
      return state.notification?.type ? state.notification.type : 'info'
    },
    notification(state) {
      return state.notification
    },
    isNotificationPresent(state) {
      return !!state.notification
    }
  }
}

export default notificationStore
